export default __webpack_public_path__ + "static/media/smart-home-nuemorphism-circle.1a93e207.png";